import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ComplaintType from '../../models/ComplaintType';


export interface ComplaintTypesState extends ApiState {
  complaintTypes?: ComplaintType[]
}

export default requestReducer<ComplaintTypesState>('COMPLAINT_TYPE_LIST')
